import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { AppState } from '@root/app-state.module';
import { ActivatedRouteSnapshot } from '@angular/router';
import { selectIsDirectLinkLoading } from '@store/user/user.selector';
import { GetDirectLinkData } from '@store/user/user.actions';
import { filter, take, tap } from 'rxjs/operators';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DirectLinkDataResolverService  {
  constructor(private readonly store$: Store<AppState>, private readonly location: Location) { }

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    if (!route.queryParamMap.has('searchType')) {
      return of(true);
    }

    this.store$.dispatch(new GetDirectLinkData());

    return this.store$.pipe(
      select(selectIsDirectLinkLoading),
      filter((isLoading: boolean) => !isLoading)
    )
    .pipe(
      take(1),
      tap(() => {
        // remove query params, so back button does not retrigger fetching direct link data
        setTimeout(() => {
          this.location.replaceState('/' + route.url.map((segment) => segment.toString()).join('/'));
        });
      })
    );
  }
}
